var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 11,
    viewBox: "0 0 100 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0306 1C36.221 2.6 35.0247 10.1207 33.0306 9.5C18.5742 5.00006 6.11154 10.5 4.61603 10.5C3.12053 10.5 -4.35699 8 3.61902 4C11.595 0 29.0426 -1 33.0306 1Z",
    className: "Brows"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9694 1C63.779 2.6 64.9753 10.1207 66.9694 9.5C81.4258 5.00006 93.8885 10.5 95.384 10.5C96.8795 10.5 104.357 8 96.381 4C88.405 0 70.9574 -1 66.9694 1Z",
    className: "Brows"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsA);
export default __webpack_public_path__ + "static/media/Brows A.10a496a43a4eea7612c437a81118b04d.svg";
export { ForwardRef as ReactComponent };